import moment from 'moment-timezone'

import { isLocalStorageAllowedSelector } from 'selectors/gdpr'
import { storePageType } from 'services/analytics/page_type'

export const inviteeLanded = () => ({
  type: 'INVITEE_LANDED',
  payload: {
    timestamp: moment()
  }
})

export const setInviteeFrom = (from) => ({
  type: 'INVITEE_SET_FROM',
  payload: {
    from
  }
})

export const setReferrerPageType = (referrerPage) => (dispatch, getState) => {
  if (isLocalStorageAllowedSelector('functional')(getState())) {
    storePageType(referrerPage)
  }

  dispatch({
    type: 'SET_REFERRER_PAGE',
    payload: referrerPage || ''
  })
}

export const setAnalyticsBookingMethod = (bookingMethod) => ({
  type: 'SET_ANALYTICS_BOOKING_METHOD',
  payload: {
    bookingMethod
  }
})
